import axios from 'axios'
import { Loading, Message } from 'element-ui'
import * as _storage from '../utils/storage'
import md5 from '../utils/md5.js'
import store from '@/store'
import router from "@/router"
const instance = axios.create()

let needLoadingRequestCount = 0

function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) {
    return false
  }
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

let loading

function startLoading () {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.2)'
  })
}

function endLoading () {
  loading.close()
}

// 请求超时 请求头
instance.defaults.timeout = 500000
instance.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'

const setXYBsign = (config) => {
  const davinciKey = 'davinci.xiaoyibang'
  const nonceStr = new Date().getTime() % 100000
  const sign = md5(nonceStr + davinciKey)
  return { sign, nonceStr }
};

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    if (config.showLoading) {
      showFullScreenLoading()
    }
    const collegeId = _storage.getStorageSync('collegeId') || ''
    config.headers = {
      ...config.headers,
      collegeId,
      ...setXYBsign(config)
    }
    return config
  },
  (err) => {
    throw err
  }
)
const catchErrorUrl = ['/api/examinee/v1/user/identityAutoAuth']
// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    if (response.config.showLoading) {
      tryHideFullScreenLoading()
    }
    if (
      response.data &&
      response.data.code < 400 &&
      response.data.code >= 200
    ) {
      if (response.data.code == '500') {
        Message.error(response.data.msg || response.data.message)
      }
      return response.data.data
    } else if (response.data.code == '500') {
      if (!catchErrorUrl.includes(response.config.url)) {
        Message.error(response.data.msg || response.data.message)
      }
      throw new Error(response.data.msg || response.data.message)
    } else if (response.data.code == '000') {
      Message.error(response.data.msg || response.data.message)
      store.commit('clearUserInfo')
      const query = JSON.parse(JSON.stringify(store.state.fromAuth))
      router.replace({
        path: '/',
        query,
      })
      // window.location.href = '#/index/login'
      throw new Error(response.data.msg || response.data.message)
    } else {
      Message.error(response.data.msg || response.data.message)
      throw new Error(response.data.msg || response.data.message)
    }
  },
  (err) => {
    console.log({ err })
    tryHideFullScreenLoading()
    throw err
  }
)

const ajax = {
  /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @param {Object} data [请求时携带的参数]
   */
  get: (url, data = {}, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      instance
        .get(url, {
          params: data,
          headers: data.headers || {},
          ...showLoadingOptions
        })
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  /**
   * delete，对应delete请求
   * @param {String} url [请求的url地址]
   * @param {Object} data [请求时携带的参数]
   */
  del: (url, data = {}, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      instance
        .delete(url, {
          data: data,
          headers: data.headers || {},
          ...showLoadingOptions
        })
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} data [请求时携带的参数]
   */
  post: (
    url,
    data = {},
    showLoadingOptions = { showLoading: true }
  ) => {
    return new Promise((resolve, reject) => {
      instance({
        url: url,
        method: 'post',
        data: data,
        headers: data.headers || {},
        ...showLoadingOptions
      })
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  /**
   * 封装patch请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  patch: (url, params, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      instance.patch(url, params, showLoadingOptions).then(
        (response) => {
          console.log('response', response)
          resolve(response)
        },
        (err) => {
          reject(err)
        }
      )
    })
  },

  /**
   * put 请求
   * @param  url
   * @param  params
   */
  put: (url, params, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      instance.put(url, params, showLoadingOptions).then(
        (response) => {
          resolve(response)
        },
        (err) => {
          reject(err)
        }
      )
    })
  }
}

export default ajax
